import React from "react";
import Chart from "react-apexcharts";

const getScoreColor = (score) => {
  if (score >= 800) return ["#22c55e", "#86efac"]; // verde
  if (score >= 600) return ["#facc15", "#fde68a"]; // amarelo
  return ["#ef4444", "#fca5a5"]; // vermelho
};

const getScoreLabel = (score) => {
  if (score >= 800) return "Excelente";
  if (score >= 600) return "Regular";
  return "Baixo";
};

export default function ScoreGaugeApex({ score = 720 }) {
  const percentage = Math.min(Math.max(score / 1000, 0), 1);
  const [primary, secondary] = getScoreColor(score);
  const label = getScoreLabel(score);

  const options = {
    chart: {
      type: "radialBar",
      sparkline: { enabled: true },
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        hollow: {
          size: "65%",
          background: "transparent",
        },
        track: {
          background: "#f3f4f6",
          strokeWidth: "100%",
          margin: 0,
        },
        dataLabels: {
          show: true,
          name: {
            show: false,
          },
          value: {
            offsetY: 8,
            fontSize: "36px",
            fontWeight: 800,
            color: "#111827",
            formatter: () => `${score}`,
          },
        },
      },
    },
    fill: {
      type: "solid",
      gradient: {
        shade: "light",
        type: "horizontal",
        gradientToColors: [secondary],
        stops: [0, 100],
      },
      colors: [primary],
    },
    stroke: {
      lineCap: "round",
    },
    labels: ["Score"],
  };

  const series = [percentage * 100];

  return (
    <div className="max-w-sm mx-auto bg-white p-3 text-center">
      <Chart options={options} series={series} type="radialBar" height={250} />
      <div className="mt-2 text-sm font-medium text-gray-500 tracking-wide">
        Classificação:{" "}
        <span className="font-semibold text-gray-700">{label}</span>
      </div>
    </div>
  );
}
